import script from "./mahasiswa.vue?vue&type=script&setup=true&lang=ts"
export * from "./mahasiswa.vue?vue&type=script&setup=true&lang=ts"

import "./mahasiswa.vue?vue&type=style&index=0&id=6325e5b9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6325e5b9"]])

export default __exports__